import Layout from "@/components/feature/Layout";
import ServicePage from "@/components/feature/ServicePage";

const data = {
  heroTitle: "Ofis ve iş yeri temizliği",
  heroDescription: "Adana'da ofis ve iş yeri temizliği için düzenli, hijyenik ve profesyonel temizlik çözümleri.",
  description: "İş yerlerinde temiz ve düzenli bir ortam, hem çalışan verimliliğini hem de müşteri izlenimini güçlendirir. Day Temizlik Adana, ofis ve iş yeri temizliğinde masa, zemin, ortak alan, mutfak, lavabo ve genel kullanım alanları için planlı temizlik çözümleri sunar. Düzenli periyodik hizmet ile iş yeriniz her zaman profesyonel görünür.",
  scope: [
    "Ofis genel temizliği",
    "Masa ve uygun yüzey temizliği",
    "Zemin temizliği",
    "Mutfak ve lavabo alanı temizliği",
    "Ortak kullanım alanları",
    "Düzenli periyodik temizlik",
  ],
  forWho: [
    "Ofis ve şirket sahipleri",
    "İş yeri yöneticileri",
    "Mağaza ve showroom işletmeleri",
    "Atölye ve üretim tesisleri",
    "Klinik ve muayenehaneler",
  ],
  process: [
    "Ofis veya iş yerinin yapısını, kullanım yoğunluğunu değerlendiriyoruz.",
    "Çalışan sayısı ve müşteri akışına göre plan hazırlıyoruz.",
    "Periyodik temizlik takvimi oluşturuyoruz.",
    "Belirlenen gün ve saatlerde düzenli temizlik uyguluyoruz.",
    "Kontrol ve geri bildirim süreciyle kaliteyi sürdürüyoruz.",
  ],
  whyProfessional: [
    "Temiz ve düzenli ofis çalışan verimliliğini artırır.",
    "Müşteri ve ziyaretçi izlenimi olumlu yönde güçlenir.",
    "Düzenli periyodik temizlik hijyen standartlarını korur.",
    "Profesyonel ekip ve ekipman daha etkili sonuç verir.",
    "Planlı hizmet sayesinde iş akışı aksamaz.",
  ],
  relatedServices: [
    { title: "Daire Temizliği", path: "/hizmetlerimiz/daire-temizligi" },
    { title: "İnşaat Sonrası Temizlik", path: "/hizmetlerimiz/insaat-sonrasi-temizlik" },
    { title: "İlaçlama", path: "/hizmetlerimiz/ilaclama" },
  ],
  faqs: [
    { question: "Ofis temizliği için periyodik hizmet var mı?", answer: "Evet, ofis ve iş yerleri için haftalık, haftada iki kez veya aylık düzenli periyodik temizlik planları oluşturuluyor." },
    { question: "Ofis temizliği ne zaman yapılır?", answer: "İş saatleri dışında, akşam veya hafta sonu gibi çalışanları rahatsız etmeyecek saatlerde yapılır." },
    { question: "Fiyatlar nasıl belirlenir?", answer: "Ofis büyüklüğü, çalışan sayısı, temizlik sıklığı ve hizmet kapsamına göre fiyat belirlenir." },
  ],
  ctaText: "Ofisiniz için profesyonel temizlik planı oluşturun.",
  heroImage: "/assets/images/ofis-temizligi.jpg",
};

export default function OfisTemizligiPage() {
  return (
    <Layout>
      <ServicePage data={data} />
    </Layout>
  );
}